import { API_URL } from '@/shared/config/env';

export async function postAnalyticsEvent(
  token: string,
  endpoint: string,
  body: Record<string, unknown>,
): Promise<void> {
  const response = await fetch(`${API_URL}/api/analytics/events/${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Analytics API error: ${response.status}`);
  }
}
